<div class="modal-wrapper">
  <div class="modal" [ngClass]="{'normal-bg-color' : saveDataFlag === false, 'save-bg-color' : saveDataFlag === true, 'primary-bg-color' : primaryLayout === true}" role="dialog"
    id="modal-dialog" aria-label="dialog-label" aria-modal="true" tabindex="-1">
    <div class="modal-header ">
      <h4 class="modal-title " [ngClass]="{'normal-bg-color' : saveDataFlag === false, 'save-bg-color' : saveDataFlag === true, 'primary-bg-color-heading' : primaryLayout === true}"
        tabindex="0" [id]="modalConfig.modalType+'-header'" #closeBtnHeader>{{modalConfig.header}}</h4>
      <button *ngIf="!primaryLayout" #closeBtn id="btn-close-modal" class="position-absolute"type="button" (click)="close()"
      (keyup.enter)="close()" aria-label="close modal button">
        <span class="icon icon-cross reflect-modal-close" aria-label="close modal button" tabindex="0" aria-hidden="true" [ngClass]="{'save-icon' : saveDataFlag === true}"></span>
        <span class="visually-hidden">close modal</span>
        <!-- <span class="access" id="text-close-modal">Close modal
        </span> -->
      </button>

    </div>
    <div class="modal-content">
      <span id="msgContent" [innerHTML]="modalConfig.content" aria-live="modalContent"></span>
    </div>
    <div class="modal-footer">
      <div class="clear-all sidebyside">
        <div #primaryBtn tabindex="0">
          <button id="footer-primary" class="{{btnClass}}" [ngClass]="{'btn-secondary' : saveDataFlag === false,'btn-save' : saveDataFlag === true, 'btn-tooltip' : tooltipFlag === true, 'primary-bg-button' : primaryLayout === true}"
          type="button" (click)="primaryBtnClickHandler()" *ngIf="modalConfig.footerPrimaryBtnLabel !== ''">{{modalConfig.footerPrimaryBtnLabel}}</button>
        </div>
          <div #secondaryBtn tabindex="0">
            <button id="footer-secondary" class="btn btn-chevron reflectChev-btn" [ngClass]="{'btn-secondary' : saveDataFlag === false,'btn-save' : saveDataFlag === true, 'btn-tooltip' : tooltipFlag === true}" type="button" (click)="secondaryBtnClickHandler()"
          *ngIf="modalConfig.footerSecondaryBtnLabel !== '' && saveDataFlag === false">{{modalConfig.footerSecondaryBtnLabel}}</button>
          </div>
         <!--   
        <strong id="footer-secondary" class="nav-btn pointer" (keyup.enter)="secondaryBtnClickHandler()" (click)="secondaryBtnClickHandler()"
          *ngIf="modalConfig.footerSecondaryBtnLabel !== ''">{{modalConfig.footerSecondaryBtnLabel}}</strong>
          -->
      </div>

      <div *ngIf="saveDataFlag === true && checkUrl()" class="col-md-6 text-right" [ngClass]="{'padding-top-10':(saveDataFlag === true && checkUrl()) ||(saveDataFlag === false || (saveDataFlag === true && loginDetail))}">
        <div >
          <div class="form-field dont-show-msg" tabindex="0" *ngIf="modalConfig.checkMessage && checkUrl()">
            <div class="form-field dont-show-msg" #secondaryBtn tabindex="0">
              <a id="mcLink" name="mcLink" tabindex="0" (click)="navTo()" (keyup.enter)="navTo()" class="form-label returnTomyQuote">{{modalConfig.checkMessage}}</a>
            </div>
          </div>
        </div>
        <!-- <span class="text-underline">Don’t show this message again</span> -->
    
      <ng-template #registerButton>
        <div class="col-md-6 text-right save-register-padding-right">
          <button id="footer-register" class="btn btn-save btn-chevron reflectChev-btn" type="button" (click)="secondaryBtnClickHandler()"
            *ngIf="modalConfig.footerSecondaryBtnLabel !== ''">{{modalConfig.footerSecondaryBtnLabel}}</button>
        </div>
      </ng-template>
    </div>
  </div>
</div>